import { render, staticRenderFns } from "./generatenote.vue?vue&type=template&id=7a2ca0ae&scoped=true"
import script from "./generatenote.vue?vue&type=script&lang=js"
export * from "./generatenote.vue?vue&type=script&lang=js"
import style0 from "./generatenote.vue?vue&type=style&index=0&id=7a2ca0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2ca0ae",
  null
  
)

export default component.exports